import { SiteFooter } from "@jkast90/kast-common/ui";

/** The quiet end of the page: the small print, Report a bug and the legal links. The account, Settings, Sign out and Delete account are on the Account page. */
export default function Footer() {
  return (
    <SiteFooter
      className="footer"
      collapsible={false}
      start={<span className="kui-muted kui-small">Salvagers is a board game by Jake. Art is human-drawn.</span>}
      legal={{ newTab: false }}
    />
  );
}
